import { Button as MuiButton, ButtonProps as MuiButtonProps, SvgIcon } from '@mui/material';
import * as styles from '@components/button/button.styles';
import { Sync } from '@assets/svgs';

export interface IButtonProps extends MuiButtonProps {
  customColor?: string;
  isLoading?: boolean;
  variant: 'outlined' | 'text' | 'contained';
  component?: React.ElementType;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export const Button = ({ children, customColor, disabled, isLoading, variant, sx, ...other }: IButtonProps) => {
  return (
    <MuiButton
      disabled={disabled || isLoading}
      variant={variant}
      sx={[
        {
          borderColor: variant === 'outlined' ? customColor : '',
          backgroundColor: variant === 'contained' ? customColor : '',
          color: variant !== 'contained' ? customColor : '',
        },
        sx ?? ({} as any),
      ]}
      disableRipple={variant === 'text'}
      {...other}
    >
      {isLoading ? (
        <>
          {children}
          <SvgIcon inheritViewBox fontSize='small' sx={{ animation: `${styles.spin} 0.9s infinite linear` }}>
            <Sync width={undefined} height={undefined} title='sync' />
          </SvgIcon>
        </>
      ) : (
        children
      )}
    </MuiButton>
  );
};
